<ng-container *ngIf="licenseStatus$ && (licenseStatus$ | async) as licenseStatusModel">
  <div *ngIf="!licenseStatusModel.Status"
    class="evaluation evaluation__overlay d-flex justify-content-center align-items-center">
    <div class="evaluation__container" id="evaluationContainer">
      <div class="evaluation__container__background-image"></div>
      <div class="evaluation__content">
        <div
          class="evaluation__content-box d-flex justify-content-center flex-column align-items-center position-absolute">
          <h2 class="evaluation__title text-uppercase">
            Your evaluation period has expired
          </h2>
          <div class="evaluation__content-wrapper d-flex flex-column justify-content-between pb-5 pt-4">
            <div class="evaluation__description mb-4">
              You can either request for extension of your evaluation period or to
              purchase a license online
            </div>
            <div class="evaluation__buttons d-flex flex-column justify-content-between w-100 mb-4">
              <button mat-raised-button class="evaluation__button w-100 mb-3">
                <a class="evaluation__button--link" href="https://monitorsanywhere.com/contact-us/" target="_blank">Request trial
                  extension</a>
              </button>
              <button mat-raised-button class="evaluation__button evaluation__button--pink w-100 mb-3">
                <a class="evaluation__button--link"
                  href="https://monitorsanywhere.com/where-to-purchase-monitors-anywhere/" target="_blank">Purchase
                  license</a>
              </button>
              <button mat-raised-button class="evaluation__button evaluation__button--gray w-100">
                <a class="evaluation__button--link" href="https://monitorsanywhere.com/" target="_blank">Visit
                  website</a>
              </button>
            </div>
            <div class="evaluation__key">
              If you already have a license key please <a href="" class="evaluation__link"
                [routerLink]="['/Admin/License']">click here</a>
            </div>
          </div>
        </div>
      </div>
      <div class="signature"></div>
    </div>
  </div>
</ng-container>